import { render, staticRenderFns } from "./inputCapEmas.vue?vue&type=template&id=80591652&"
import script from "./inputCapEmas.vue?vue&type=script&lang=js&"
export * from "./inputCapEmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports